import { createContext, useContext } from 'react'
import { DEFAULT_GRADE_CONFIG, type GymGradeConfig } from '@structural-climbing/validation'

// A defaulted context (never throws) so leaf components — the route modals —
// can read the gym's configured grade scale without prop drilling, and still
// render in isolation (tests, storybook) where no provider is mounted. Mirrors
// GymThemeContext. GymLayout feeds it the value from GymContext.
export const GymGradeConfigContext = createContext<GymGradeConfig>(DEFAULT_GRADE_CONFIG)

export function useGymGradeConfig(): GymGradeConfig {
  return useContext(GymGradeConfigContext)
}
